import { render, staticRenderFns } from "./AdminUsuariosComponent.vue?vue&type=template&id=b1ee5b4c&"
import script from "./AdminUsuariosComponent.vue?vue&type=script&lang=js&"
export * from "./AdminUsuariosComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports